export const REQUEST_TESTS = 'assessmentTests/REQUEST_TESTS';
export const RECEIVE_TESTS = 'assessmentTests/RECEIVE_TESTS';
export const UPDATE_TEST = 'assessmentTests/UPDATE_TEST';
export const CLEAR_TEST = 'assessmentTests/CLEAR_TEST';
